import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import {
  Form,
  FormHeader,
  FormFooter,
  CheckboxElement,
  TextfieldElement,
  Button,
  FormSubmit,
  SelectElement,
  RadiosElement,
  Role,
  Table,
  ButtonSecondary,
  ResultsCounter,
  Actions,
  FormMandatoryPrompt,
  withCourseContactApi,
  withProvidersApi,
  AutocompleteTextfieldApiElement,
} from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";
import i18n from "../../../i18n";
import { LANGUAGE_EN, ROLE_STAFF } from "../../../constants";
import { Link } from "react-router-dom";
import { route } from "../../../routes";
import moment from "moment";

class CourseGroupsCreateEditForm extends Component {
  /**
   * render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        {this.props.mode === "edit" &&
          this.props.audit &&
          this.props.audit.createdBy && (
            <p>
              <strong>
                {this.props.t(
                  "local:view.courseGroups.edit.field.createdBy.label"
                )}
              </strong>
              : {this.props.audit.createdBy.name}{" "}
              {moment(this.props.audit.dateCreated).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </p>
          )}

        {this.props.mode === "edit" &&
          this.props.audit &&
          this.props.audit.updatedBy && (
            <p>
              <strong>
                {this.props.t(
                  "local:view.courseGroups.edit.field.updatedBy.label"
                )}
              </strong>
              : {this.props.audit.updatedBy.name}{" "}
              {moment(this.props.audit.dateUpdated).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </p>
          )}

        <Form>
          <FormHeader
            title={this.props.t(
              "local:view.courseGroups." + this.props.mode + ".formTitle"
            )}
            introduction={this.props.t(
              "local:view.courseGroups." + this.props.mode + ".formDescription"
            )}
          >
            <FormMandatoryPrompt />
          </FormHeader>

          {/* Main provider */}
          <Role roles={[ROLE_STAFF]}>
            <AutocompleteTextfieldApiElement
              api={this.props.providersApiGetEndpoint("providers_api_provider")}
              authorize={true}
              size={"large"}
              name={"mainProvider"}
              anchorId={"mainProvider.atlasAccountId"}
              label={this.props.t(
                "local:view.courseGroups.create.field.mainProvider.label"
              )}
              queryParameter={"name"}
              acceptLanguage={i18n.language}
              keyField={"atlasAccountId"}
              valueField={"providerName"}
              placeholder={this.props.t(
                "local:view.courseGroups.create.field.mainProvider.placeholder"
              )}
              value={this.props.values.mainProviderId}
              required={true}
              keyword={this.props.values.mainProviderLabel}
              errors={this.props.formErrors["mainProvider.atlasAccountId"]}
              onChange={(e) => {
                this.props.clearPermissions();
                this.props.handleChange(e);
              }}
            />
          </Role>

          {/* Course Group Type */}
          <SelectElement
            size={"large"}
            id={"courseGroupType"}
            name={"courseGroupType"}
            label={this.props.t(
              "local:view.courseGroups.create.field.courseGroupType.label"
            )}
            description={this.props.t(
              "local:view.courseGroups.create.field.courseGroupType.description"
            )}
            value={this.props.values.courseGroupType}
            disabled={this.props.authentication.hasRole("Courses_Provider")}
            onChange={this.props.handleChange}
            required={true}
            errors={this.props.formErrors.courseGroupType}
            options={[
              {
                value: "",
                label: this.props.t(
                  "local:view.courseGroups.create.field.courseGroupType.select"
                ),
              },
            ].concat(this.props.courses.assets.courseGroups.courseGroupType)}
          />

          {/* You must choose a main provider before you can access the rest of the form */}
          {(this.props.values.mainProviderId ||
            this.props.formErrors.courseGroupName) && (
            <Fragment>
              {/* sub contractor section is only visible if you select work based learning */}
              {(this.props.values.courseGroupType === "267040002" ||
                this.props.values.courseGroupType === "267040003") && (
                <Fragment>
                  {/* Subcontractor */}
                  <Role roles={[ROLE_STAFF]}>
                    <RadiosElement
                      size={"medium"}
                      id={"subContracted"}
                      name={"subContracted"}
                      label={this.props.t(
                        "local:view.courseGroups.create.field.subContracted.label"
                      )}
                      description={this.props.t(
                        "local:view.courseGroups.create.field.subContracted.description"
                      )}
                      value={this.props.values.subContracted}
                      defaultChecked={this.props.values.subContracted}
                      onChange={this.props.handleChange}
                      options={[
                        {
                          value: "yes",
                          label: this.props.t(
                            "local:view.courseGroups.create.field.subContracted.yes"
                          ),
                        },
                        {
                          value: "no",
                          label: this.props.t(
                            "local:view.courseGroups.create.field.subContracted.no"
                          ),
                        },
                      ]}
                    />
                  </Role>
                  {/* subContractedProvider */}
                  {this.props.values.subContracted === "yes" && (
                    <AutocompleteTextfieldApiElement
                      api={this.props.providersApiGetEndpoint(
                        "providers_api_provider"
                      )}
                      authorize={true}
                      size={"large"}
                      name={"subContractedProvider"}
                      anchorId={"subContractedProviderId"}
                      label={this.props.t(
                        "local:view.courseGroups.create.field.subContractedProvider.label"
                      )}
                      description={this.props.t(
                        "local:view.courseGroups.create.field.subContractedProvider.description"
                      )}
                      disabled={this.props.authentication.hasRole(
                        "Courses_Provider"
                      )}
                      queryParameter={"name"}
                      acceptLanguage={i18n.language}
                      keyField={"atlasAccountId"}
                      valueField={"providerName"}
                      placeholder={this.props.t(
                        "local:view.courseGroups.create.field.subContractedProvider.placeholder"
                      )}
                      value={this.props.values.subContractedProviderId}
                      keyword={this.props.values.subContractedProviderLabel}
                      errors={this.props.formErrors.subContractedProviderId}
                      onChange={this.props.handleChange}
                    />
                  )}
                </Fragment>
              )}

              <AutocompleteTextfieldApiElement
                api={this.props.courseContactApiGetEndpoint(
                  "course_contact_api_contacts_mq"
                )}
                authorize={true}
                size={"large"}
                name={"contact"}
                label={this.props.t(
                  "local:view.courseGroups.create.field.contact.label"
                )}
                description={this.props.t(
                  "local:view.courseGroups.create.field.contact.description"
                )}
                hasButton={true}
                queryParameter={"search"}
                additionalParameters={{
                  atlasAccountId: this.props.values.mainProviderId,
                }}
                acceptLanguage={i18n.language}
                keyField={"id"}
                valueField={"contactName"}
                dataFields={["contactName", "email", "telephoneNumber"]}
                placeholder={this.props.t(
                  "local:view.courseGroups.create.field.contact.placeholder"
                )}
                value={this.props.values.contactId}
                keyword={this.props.values.contactLabel}
                errors={this.props.formErrors.contact}
                onChange={this.props.handleChange}
                suffix={
                  <Fragment>
                    <Button
                      disabled={
                        Array.from(this.props.values.contacts).length > 0
                      }
                      classes={[
                        "button",
                        "button--suffix",
                        "button--style-blue",
                      ]}
                      onClick={this.props.handleAddContact}
                    >
                      {this.props.t(
                        "local:view.courseGroups.create.field.contact.addContact"
                      )}
                    </Button>
                  </Fragment>
                }
              />

              {this.props.values.contactsLoaded.length > 0 && (
                <Fragment>
                  <ResultsCounter
                    count={this.props.values.contactsLoaded.length}
                  >
                    <span>
                      {this.props.values.contactsLoaded.length === 1
                        ? this.props.t(
                            "local:view.courseGroups.create.field.contact.result"
                          )
                        : this.props.t(
                            "local:view.courseGroups.create.field.contact.results"
                          )}
                    </span>
                    <Actions>
                      <ButtonSecondary
                        classes={["button--large"]}
                        onClick={this.props.handleRemoveContacts}
                      >
                        {this.props.t(
                          "local:view.courseGroups.create.field.contact.removeContact"
                        )}
                      </ButtonSecondary>
                    </Actions>
                  </ResultsCounter>
                  <Table
                    headers={[
                      this.props.t(
                        "local:view.courseGroups.create.field.contacts.select"
                      ),
                      this.props.t(
                        "local:view.courseGroups.create.field.contacts.name"
                      ),
                      this.props.t(
                        "local:view.courseGroups.create.field.contacts.email"
                      ),
                      this.props.t(
                        "local:view.courseGroups.create.field.contacts.telephone"
                      ),
                    ]}
                    rows={Array.from(this.props.values.contactsLoaded).map(
                      (element) => {
                        return [
                          <CheckboxElement
                            onChange={this.props.handleSelectContact}
                            checked={this.props.values.contactsSelected.has(
                              element.id
                            )}
                            value={element.id}
                          />,
                          element.contactName[LANGUAGE_EN],
                          element.email[LANGUAGE_EN],
                          element.telephoneNumber[LANGUAGE_EN],
                        ];
                      }
                    )}
                  />
                </Fragment>
              )}

              {/* Course Group Name */}
              <TextfieldElement
                size={"medium"}
                label={this.props.t(
                  "local:view.courseGroups.create.field.courseGroupName.label"
                )}
                id={"courseGroupName"}
                description={this.props.t(
                  "local:view.courseGroups.create.field.courseGroupName.description"
                )}
                name={"courseGroupName"}
                value={this.props.values.courseGroupName}
                onChange={this.props.handleChange}
                errors={this.props.formErrors.courseGroupName}
                onKeyPress={this.context.preventDefaultOnEnter}
                required={true}
              />

              {this.props.mode === "edit" &&
                this.props.values.courseCount >= 0 && (
                  <Link
                    to={
                      route("coursesManage") +
                      "?courseGroupId=" +
                      this.props.values.id +
                      "&courseGroupLabel=" +
                      this.props.values.courseGroupName
                    }
                    className={"style--icon-right-chevron-right"}
                  >
                    {this.props.t(
                      "local:view.courseGroups.create.field.courseGroupName.viewAll",
                      { count: this.props.values.courseCount }
                    )}
                  </Link>
                )}

              {this.props.values.users.length > 0 && (
                <Fragment>
                  <h2>
                    {this.props.t(
                      "local:view.courseGroups.create.field.courseGroupPermissions.title"
                    )}
                  </h2>
                  <p>
                    {this.props.t(
                      "local:view.courseGroups.create.field.courseGroupPermissions.description"
                    )}
                  </p>
                  <div className="table tab js-table">
                    <div className="table__container">
                      <table>
                        <thead>
                          <tr>
                            <th>
                              {this.props.t(
                                "local:view.courseGroups.create.field.courseGroupPermissions.table.select"
                              )}
                            </th>
                            <th>
                              {this.props.t(
                                "local:view.courseGroups.create.field.courseGroupPermissions.table.contactName"
                              )}
                            </th>
                            <th>
                              {this.props.t(
                                "local:view.courseGroups.create.field.courseGroupPermissions.table.email"
                              )}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.values.users.map((element) => {
                            return (
                              <tr>
                                <td>
                                  <CheckboxElement
                                    onChange={
                                      this.props.handleBulkPermissionsCheckbox
                                    }
                                    checked={this.props.values.permissions.has(
                                      element.id
                                    )}
                                    value={element.id}
                                  />
                                </td>
                                <td>{element.name}</td>
                                <td>{element.email}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Fragment>
              )}

              <FormFooter>
                <FormSubmit
                  title={this.props.t("styleguide:forms.submit")}
                  value={this.props.t("styleguide:forms.submit")}
                  icon={{ type: "chevron-right", position: "right" }}
                  onClick={(event) => {
                    event.preventDefault();
                    this.props.saveCourseGroup();
                  }}
                  spinner={this.props.submitting ? "spinner" : null}
                >
                  {this.props.t("styleguide:forms.save")}
                </FormSubmit>
              </FormFooter>
            </Fragment>
          )}
        </Form>
      </Fragment>
    );
  }
}

export default withCourseContactApi(process.env)(
  withProvidersApi(process.env)(
    withAssets(withTranslation("local")(CourseGroupsCreateEditForm))
  )
);
